import { call, all } from "redux-saga/effects";

import TelematicsSaga from "./telematics.saga";
import TelematicsAggregationsSaga from "./telematicsAggregations.saga";
import TelematicsMachinesSaga from "./telematicsMachines.saga";

export default function* commonSaga(): Generator {
  yield all([
    call(TelematicsSaga),
    call(TelematicsAggregationsSaga),
    call(TelematicsMachinesSaga),
  ]);
}
